export default class Purchase {

  constructor(purchaseObj) {
    this.purchase = purchaseObj;
  }

  static fromJson(jsonProductos) {
    const productos = jsonProductos.map(p => {
      p.cantidad = 0;
      return p;
    });

    const cesta = {};
    productos.forEach(p => {
      cesta[p.Id] = p;
    });

    return new Purchase({
      cesta: cesta,
      cestaVisible: [],
      cestaTotal: 0,
      cestaCantidadTotal: 0,
      productos: productos,
    });
  }

  cestaToPair() {
    return this.purchase.cestaVisible.map(c => {
      return {id: c.Id, cantidad: c.cantidad};
    });
  }

  getCestaTotal() {
    return this.purchase.cestaTotal;
  }

  getCestaCantidadTotal() {
    return this.purchase.cestaCantidadTotal;
  }

  notEmpty() {
    return this.purchase.cestaCantidadTotal > 0;
  }

  isEmpty() {
    return this.purchase.cestaCantidadTotal === 0;
  }

  getCestaVisible() {
    return this.purchase.cestaVisible;
  }

  getProductos() {
    return this.purchase.productos;
  }

  add(producto) {

    setTimeout(function () {
      $("#cesta").addClass("flash-cesta");
    }, 1);


    this.purchase.cesta[producto.Id].cantidad++;
    this.refreshCestaVisible();
  }

  substract(producto) {

    setTimeout(function () {
      $("#cesta").addClass("flash-cesta");
    }, 1);


    if (producto.cantidad - 1 >= 0)
      producto.cantidad--;
    this.refreshCestaVisible();
  }

  eliminar(producto) {
    producto.cantidad = 0;
    this.refreshCestaVisible();
  }

  refreshCestaVisible() {
    this.purchase.cestaVisible = Object.keys(this.purchase.cesta)
        .map(key => this.purchase.cesta[key])
        .filter(p => p.cantidad > 0);

    this.purchase.cestaCantidadTotal = this.purchase.productos
        .filter(p => p.cantidad > 0)
        .map(p => parseInt(p.cantidad, 10))
        .reduce((a, b) => a + b, 0);

    this.purchase.cestaTotal = this.purchase.productos
        .filter(p => p.cantidad > 0)
        .map(p => p.cantidad * p.PrecioUnidad)
        .reduce((a, b) => a + b, 0);
  }
};


// WEBPACK FOOTER //
// ./oferta-navidad/purchase.js